import { ArrowUpRight, Phone } from "lucide-react";
import { SERVICES, PHONE_LINK, Reveal, Eyebrow } from "../lib/data";

const Services = () => (
  <section id="servicii" className="py-20 lg:py-28 bg-[#FBF7EF]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal className="max-w-2xl">
        <Eyebrow>Servicii stomatologice</Eyebrow>
        <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">
          Toate tratamentele dentare, sub un singur acoperiș
        </h2>
        <p className="text-[#6B5C43] mt-4 text-base md:text-lg">
          De la prevenție la implanturi — alegem împreună tratamentul potrivit, la o consultație. Fără grabă, fără surprize.
        </p>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={(i % 4) * 0.08} className={s.featured ? "sm:col-span-2 lg:row-span-2" : ""}>
            <a
              href={PHONE_LINK}
              data-testid={`service-card-${s.id}`}
              className={`group h-full flex flex-col rounded-2xl border p-6 transition-all hover:-translate-y-1 ${
                s.featured
                  ? "bg-[#2A2521] border-[#2A2521] text-white shadow-xl shadow-[#2A2521]/20 lg:p-8"
                  : "bg-white border-[#EADFC6] hover:shadow-xl hover:shadow-[#A6823B]/10"
              }`}
            >
              <div className="flex items-start justify-between">
                <span className={`w-12 h-12 rounded-xl flex items-center justify-center ${s.featured ? "bg-[#A6823B]/20" : "bg-[#EFE7D6]"}`}>
                  <s.icon className={`w-6 h-6 ${s.featured ? "text-[#DCC79A]" : "text-[#A6823B]"}`} />
                </span>
                <ArrowUpRight className={`w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity ${s.featured ? "text-[#DCC79A]" : "text-[#A6823B]"}`} />
              </div>
              <h3 className={`font-display font-bold mt-5 ${s.featured ? "text-2xl" : "text-lg text-[#2A2521]"}`}>{s.name}</h3>
              <p className={`mt-2 text-sm leading-relaxed flex-1 ${s.featured ? "text-white/75" : "text-[#6B5C43]"}`}>{s.desc}</p>
              <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold">
                <Phone className={`w-4 h-4 ${s.featured ? "text-[#DCC79A]" : "text-[#A6823B]"}`} />
                <span className={s.featured ? "text-[#DCC79A]" : "text-[#A6823B]"}>Sună pentru programare</span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
